module.exports = __webpack_public_path__ + "static/media/1.question_loop.2f2d7e0b.mp4";